import React, { useEffect } from 'react';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';

import { withFlags, type WithFlagsProps } from '@confluence/flags/entry-points/withFlags.ts';

/**
 * Component that checks for move success parameters in the URL and shows a success flag
 * This allows the success message to persist across page reloads after moving a page
 */
export const MovePageSuccessFlag = withFlags(({ flags }: WithFlagsProps) => {
	const intl = useIntl();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const moved = urlParams.get('moved');

		if (moved === 'success') {
			// Show the success flag
			void flags.showSuccessFlag({
				title: <FormattedMessage {...i18n.movePageItemMovedTitle} />,
				isAutoDismiss: true,
			});

			// Clean up URL parameters without causing a page reload
			urlParams.delete('moved');
			const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
			const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
			window.history.replaceState({}, '', newUrl);
		}
	}, [flags, intl]);

	return null;
});

const i18n = defineMessages({
	movePageItemMovedTitle: {
		id: 'page-tree.move-page.flag.success',
		defaultMessage: 'Item moved',
		description: 'Title for the flag notifying user that we successfully moved the target page',
	},
});
